import { ReactNode, useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import ArrowDown from "@/assets/icons/ArrowDown.svg";
import WhiteCheck from "@/assets/icons/WhiteCheck.svg";
import { Badge } from "@/components/ui/Badge";

type TNestedAccordionProps = {
  children: ReactNode;
  title?: string;
  status?: string;
  initiated?: boolean;
  isApproved?: boolean;
  inProgress?: boolean;
  timeLine?: string;
  actionRequired?: boolean;
  isPulse?: boolean;
  initiallyOpen?: boolean;
  showTimeLine?:boolean,
  isOpen?: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const NestedAccordion = ({
  children,
  title,
  showTimeLine=true,
  initiated = false,
  status,
  isApproved,
  timeLine,
  actionRequired,
  inProgress,
  isPulse,
  isOpen,
  setIsOpen,
}: // initiallyOpen = false,
TNestedAccordionProps) => {
  const [contentHeight, setContentHeight] = useState("auto");
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      setContentHeight(`${contentRef.current.scrollHeight}px`);
    } else {
      setContentHeight("0px");
    }
  }, [isOpen, children]);

  // useEffect(() => {
  //   setIsOpen(initiallyOpen);
  // }, [initiallyOpen]);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };

  const arrowAnimation = {
    animate: { rotate: isOpen ? 180 : 0 },
    transition: { duration: 0.3, ease: "easeInOut" },
  };

  // Making time line days to hours for mobile device
  // let totalHours = 0;
  // if (timeLine && typeof timeLine === "string") {
  //   const daysMatch = timeLine.match(/(\d+)\s*days?/);
  //   const hoursMatch = timeLine.match(/(\d+)\s*hours?/);
  //   const days = daysMatch ? parseInt(daysMatch[1], 10) : 0;
  //   const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
  //   totalHours = days * 24 + hours;
  // }

  // // console.log("timeLine:", timeLine, "Total hours:", totalHours);
  // // console.log(timeLine);

  return (
    <div className="mx-5 border-[1.5px] border-[#F0EEEE] rounded-xl h-fit overflow-hidden">
      <motion.div className="cursor-pointer" onClick={handleOpen}>
        <div className="flex items-center py-[10px] px-3">
          <p className="text-sm font-medium text-black mr-auto">{title}</p>

          {initiated ? (
            <div className="flex gap-1.5 md:gap-4 items-center">
              {!isOpen && (
                <>
                  {actionRequired ? (
                    <Badge type="Pending">Action Required</Badge>
                  ) : (
                    <>
                      {status && (
                        <div>
                          {isApproved || inProgress ? (
                            <>
                              {isApproved && (
                                <Badge type="Success">
                                <div className="rounded-full">  <WhiteCheck /></div> {status}
                                </Badge>
                              )}

                              {inProgress && (
                                <Badge type="Pending">{status}</Badge>
                              )}
                            </>
                          ) : (
                            <Badge type="Pending">{status}</Badge>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}


              { showTimeLine && timeLine !== "0 Min" && (
                <>
                  {!isApproved && (
                    <>
                      <p className="text-[#475467] text-sm md:hidden font-medium">
                        Timeline: 36 hours
                      </p>
                      <p className="text-[#475467] text-[12px] hidden md:block font-medium">
                        Timeline: {timeLine}
                      </p>
                    </>
                  )}
                </>
              )}
            </div>
          ) : (
            <p
              className={`text-xs font-medium flex items-center  px-2 py-1 rounded-full gap-x-1  bg-[#E9F5EF] text-[#475467] ms-auto`}
            >
              Not Initiated Yet
            </p>
          )}
          <div className="flex gap-6 ml-1 md:ml-3">
            <motion.div {...arrowAnimation}>
              <ArrowDown />
            </motion.div>
          </div>
        </div>
      </motion.div>
      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: contentHeight, opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            onAnimationComplete={() => {
              if (contentRef.current) {
                setContentHeight("auto");
              }
            }}
            style={{ overflow: "hidden" }}
          >
            <div
              ref={contentRef}
              className="w-full py-3 border-t-[1.5px] border-[#F0EEEE]"
            >
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default NestedAccordion;
